/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */
import Util from '@/util';

const theState = {
    loading: false,
    isCheckingCustomer: false,
    existInEvalanche: false,
    ssoId: '',
    email: '',
    first_name: '',
    last_name: '',
    gender: '',
    store: null,
};

const getters = {
    fullname(state) {
        return Util.masterdataToFullName(state);
    },
};

const actions = {
    checkCustomer({ commit }, ssoId) {
        commit('setSsoId', ssoId);
        commit('setLoading', true);
        commit('setIsCheckingCustomer', true);
        return new Promise((resolve, reject) => {
            Api.customer.checkRecoverPassword(ssoId)
                .then(({ data }) => {
                    commit('setLoading', false);
                    commit('setIsCheckingCustomer', false);
                    commit('setMasterdata', data);
                    resolve();
                })
                .catch(() => {
                    commit('setIsCheckingCustomer', false);
                    commit('setLoading', false);
                    reject();
                });
        });
    },

    resetPassword({ commit, state }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Api.customer.recoverPassword(state.ssoId, state.store)
                .then(() => {
                    commit('setLoading', false);
                    resolve();
                })
                .catch(() => {
                    commit('setLoading', false);
                    reject();
                });
        });
    },
};

const mutations = {
    resetState(state) {
        state.loading = false;
        state.ssoId = '';
        state.email = '';
        state.first_name = '';
        state.last_name = '';
        state.gender = '';
        state.store = null;
        state.existInEvalanche = false;
        state.isCheckingCustomer = false;
    },

    setStore(state, store) {
        state.store = store;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setIsCheckingCustomer(state, isCheckingCustomer) {
        state.isCheckingCustomer = isCheckingCustomer;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    setMasterdata(state, {
        login,
        last_name,
        first_name,
        gender,
        store,
    }) {
        state.email = login;
        /* eslint-disable-next-line camelcase */
        state.last_name = last_name;
        /* eslint-disable-next-line camelcase */
        state.first_name = first_name;
        state.gender = gender;
        // ACHTUNG! Hier muss unbedingt die Kontrolle auf den Datentyp erfolgen
        //     - Wenn store -> null, dann existiert der Kunde in Evalanche,
        //       ist aber keinem Store zugeordnet
        //     - Wenn store -> false, dann existiert der Kunde nicht in Evalanche
        //     - Wenn store -> int, dann existiert der Kunde in Evalanche und
        //       ist mindestens einem Store zugeordnet
        state.existInEvalanche = store !== null;
        state.store = store;
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
